"use strict";

function HomePublicIDTransformer(Util, jsonMapper, serviceResponseRepository) {
	var currentResponse = null ;

	function forgePublicId(moduleName) {
		return Util.stringFormat('portal:{0}-{1}', moduleName, Util.generateRandomString(15) );
	}

	function hash(value) {
		return md5(value);
	}

	function fetchFromPreviousResponse(path) {
		if ( currentResponse )
			return Util.findHierarchyStringInObject(currentResponse, path , '.') ;

		return null;
	}


	function convertPublicID(path, moduleName) {
		if ( currentResponse ) {
			var lastPublicID =  fetchFromPreviousResponse(path) ;
			if ( lastPublicID )
				return lastPublicID;
		}

		return forgePublicId(moduleName) ;
	}


	var moduleNameMapping = {
		'policyHolders' : 'PolicyHolder',
		'policyHoldersContact' : 'PolicyHolder',
		'policyAddress' : 'Address',
		"dwellings":"QPHDwelling", // AbstractQPHDwelling
		"mortgagees":"QPHMortgagee",
		"cycles":"QPHCycle",
		"cycleEquipments":"QPHCycleEquipment",
		"pattern": "qbePattern",
		"dwellingHistory": "QPHDwellingHistory",
		"dwellingHistories": "QPHDwellingHistoryDTO"
	};

	var publicIDTransformationMapping = {
		'policyAddress.publicID' :  function() { return forgePublicId(moduleNameMapping.policyAddress)  },
		'policyHolders.*.publicID' : function() { return forgePublicId(moduleNameMapping.policyHolders)  },
		'policyHolders.*.contact.dwellingHistory.*.publicID' : function() { return forgePublicId(moduleNameMapping.dwellingHistory)  },
		"dwellings.0.publicID": function() { return forgePublicId(moduleNameMapping.dwellings)},
		"dwellings.0.location.publicID": function() { return forgePublicId(moduleNameMapping.policyAddress)},
		"policyHolders.*.contact.publicID": function() { return forgePublicId(moduleNameMapping.policyHoldersContact)},
		"policyHolders.*.contact.authorisedPersons.*.person.publicID": function() { return forgePublicId(moduleNameMapping.policyHoldersContact)},
		"policyHolders.*.contact.authorisedPersons.*.person.primaryAddress.publicID": function() { return forgePublicId(moduleNameMapping.policyAddress)},
		"policyHolders.*.contact.primaryAddress.publicID": function() { return forgePublicId(moduleNameMapping.policyAddress)},
		"dwellings.*.mortgagees.*.publicID":function() { return forgePublicId(moduleNameMapping.mortgagees)},
		"dwellings.*.policyOption.cycles.*.publicID":function() { return forgePublicId(moduleNameMapping.cycles)},
		"dwellings.*.policyOption.cycleEquipments.*.publicID":function() { return forgePublicId(moduleNameMapping.cycleEquipments)},
		"dwellings.*.dwellingHistories.*.publicID":function() { return forgePublicId(moduleNameMapping.dwellingHistories)},
	};

	var publicIDConversionMapping = {
		'policyAddress.publicID' :  function(val) { return convertPublicID('policyAddress.publicID', moduleNameMapping.policyAddress);} ,
		'policyHolders.*.publicID' : function(val, mappedValueStarIndices) {
			return convertPublicID('policyHolders.' + mappedValueStarIndices[0] + '.publicID', moduleNameMapping.policyHolders);
		},
		'policyHolders.*.contact.dwellingHistory.*.publicID' : function(val, mappedValueStarIndices) {
			return convertPublicID('policyHolders.' + mappedValueStarIndices[0] + '.contact.dwellingHistory.'  + mappedValueStarIndices[1] + '.publicID' , moduleNameMapping.dwellingHistory);
		},
		"policyHolders.*.contact.authorisedPersons.*.person.publicID": function(val, mappedValueStarIndices) {
			return convertPublicID('policyHolders.' + mappedValueStarIndices[0] + '.contact.authorisedPersons.'+ mappedValueStarIndices[1] + '.person.publicID' , moduleNameMapping.policyHoldersContact);
		},
		"policyHolders.*.contact.authorisedPersons.*.person.primaryAddress.publicID": function(val, mappedValueStarIndices) {
			return convertPublicID('policyHolders.' + mappedValueStarIndices[0] + '.contact.authorisedPersons.'+ mappedValueStarIndices[1] + '.person.primaryAddress.publicID', moduleNameMapping.policyAddress);
		},
		"dwellings.0.publicID": function(val) { return convertPublicID('dwellings.0.publicID', moduleNameMapping.dwellings);} ,
		"dwellings.0.location.publicID": function(val) { return convertPublicID('dwellings.0.location.publicID', moduleNameMapping.policyAddress);},
		'policyHolders.*.contact.publicID' : function(val, mappedValueStarIndices) {
			return convertPublicID('policyHolders.' + mappedValueStarIndices[0] + '.contact.publicID', moduleNameMapping.policyHoldersContact);
		},
		'policyHolders.*.contact.primaryAddress.publicID' : function(val, mappedValueStarIndices) {
			return convertPublicID('policyHolders.' + mappedValueStarIndices[0] + '.contact.primaryAddress.publicID', moduleNameMapping.policyAddress);
		},
		'dwellings.*.mortgagees.*.publicID':function(val, mappedValueStarIndices) {
			return convertPublicID('dwellings.' + mappedValueStarIndices[0] +  '.mortgagees.' + mappedValueStarIndices[1] + '.publicID', moduleNameMapping.mortgagees);
		},
		'dwellings.*.policyOption.cycles.*.publicID':function(val, mappedValueStarIndices) {
			return convertPublicID('dwellings.' + mappedValueStarIndices[0] +  '.policyOption.cycles.' + mappedValueStarIndices[1] + '.publicID', moduleNameMapping.cycles);
		},
		'dwellings.*.policyOption.cycleEquipments.*.publicID':function(val, mappedValueStarIndices) {
			return convertPublicID('dwellings.' + mappedValueStarIndices[0] +  '.policyOption.cycleEquipments.' + mappedValueStarIndices[1] + '.publicID', moduleNameMapping.cycleEquipments);
		},
		'dwellings.*.dwellingHistories.*.publicID':function(val, mappedValueStarIndices) {
			return convertPublicID('dwellings.' + mappedValueStarIndices[0] +  '.dwellingHistories.' + mappedValueStarIndices[1] + '.publicID', moduleNameMapping.dwellingHistories);
		},
	};

	function transform(intermediateRequest, response, quickQuote) {

		currentResponse = response ;

		var transformedRequest = intermediateRequest;
		if ( !currentResponse || quickQuote )
		 	transformedRequest = jsonMapper.transform(intermediateRequest, publicIDTransformationMapping) ;
		else
		 	transformedRequest = jsonMapper.convert(intermediateRequest, publicIDConversionMapping) ;

		return transformedRequest;
	}

	return {
		transform: transform
	}
}
